<template>
  <alert-form
    :id="0"
    @submit="addAlert"
    @close="$emit('close')"
  />
</template>

<script>
import AlertForm from '../Form.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'CreateAlert',
  components: { AlertForm },
  methods: {
    addAlert(alert) {
      const query = {
        alert: {
          name: alert.name,
          healthcheckId: alert.healthcheck.id,
          providers: alert.providers,
          message: alert.message,
        },
      }
      this.$store
        .dispatch('alerts/addAlert', query)
        .then(() => {
          this.successToast('Alert was added!')
          this.$emit('onRefresh')
        })
        .catch(error => {
          redirectError(error)
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while creating alert!',
          )
        })
    },
  },
}
</script>
